import {TimbraturaRecord} from "@commons/mapping/TimbraturaLavRecord"
import {DateTime} from "luxon"
import classNames from "classnames";

export const Timbratura: React.FC<{ timbratura: Pick<TimbraturaRecord, 'tsTimbratura' | 'verso' | 'rimossa' | 'manuale'>, scala?: 0.5 | 1 | 1.25 | 1.5 | 2 }> = ({
                                                                                                                                                                     timbratura,
                                                                                                                                                                     scala = 1
                                                                                                                                                                 }) => {
    //console.log('timbratura',timbratura)
    return <div className="flex flex-row gap-0">

        {timbratura.verso === 'ENTRATA' && <DoorEnter width={24 * scala} height={24 * scala}/>}
        {timbratura.verso === 'USCITA' && <DoorExit width={24 * scala} height={24 * scala}/>}

        <div className={classNames(
            scala === 0.5 && 'text-[7px]',
            scala === 1 && 'text-[14px]',
            scala === 1.25 && 'text-[18px]',
            scala === 1.5 && 'text-[21px]',
            scala === 2 && 'text-[28px]',
            timbratura.rimossa && 'line-through',
            !timbratura.manuale && timbratura.verso === 'ENTRATA' && 'bg-timb-entrata text-timb-entrata',
            !timbratura.manuale && timbratura.verso === 'USCITA' && 'bg-timb-uscita text-timb-uscita',
        )
        }>
            <span className={classNames(
                !timbratura.manuale && timbratura.verso === 'ENTRATA' && 'text-timb-entrata',
                !timbratura.manuale && timbratura.verso === 'USCITA' && 'text-timb-uscita',
                timbratura.manuale && 'text-red-700 font-bold',
            )}>{DateTime.fromISO(timbratura.tsTimbratura!).toFormat('HH:mm')}</span>
        </div>
    </div>
}

const DoorEnter: React.FC<{ width: number, height: number }> = ({width, height}) => {
    // @ts-ignore
    let color = '#ffad13';//=colors.timbratura.entrata;
    return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="Door-Open-Enter--Streamline-Outlined-Expansion" height={height ?? "24"}
                width={width ?? "24"}>
        <g id="door-open-enter">
            <path id="Union" fill={color ?? "#000000"} fillRule="evenodd"
                  d="M14 4H7.37321l2.96309 1.05826 0.6637 0.23702V18h3v-1.5h2V20h-5v1.919l-1.33634 -0.4773 -7 -2.5L2 18.7047V2h14v3.5h-2V4ZM4 4.919v12.3763l5 1.7857V6.70472L4 4.919ZM16 15l1.4 -1.4 -1.575 -1.6H22v-2h-6.175L17.4 8.4 16 7l-4 4 4 4Z"
                  clipRule="evenodd" strokeWidth="1"></path>
        </g>
    </svg>
}

const DoorExit: React.FC<{ width: number, height: number }> = ({width, height}) => {
    // @ts-ignore
    let color = '#00b70f';//=colors.timbratura.uscita;
    return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="Door-Open-Exit--Streamline-Outlined-Expansion" height={height ?? "24"} width={width ?? "24"}>
        <g id="door-open-exit">
            <path id="Union" fill={color ?? "#000000"} fillRule="evenodd"
                  d="M14 4H7.37321l2.96309 1.05826 0.6637 0.23702V18h3v-1.5h2V20h-5v1.919l-1.33634 -0.4773 -7 -2.5L2 18.7047V2h14v3.5h-2V4ZM4 4.919v12.3763l5 1.7857V6.70472L4 4.919ZM18 15l-1.4 -1.4 1.575 -1.6H12v-2h6.175L16.6 8.4 18 7l4 4 -4 4Z"
                  clipRule="evenodd" strokeWidth="1"></path>
        </g>
    </svg>;
}